import { render, staticRenderFns } from "./form-builder.vue?vue&type=template&id=00c29dd5&"
import script from "./form-builder.vue?vue&type=script&lang=ts&"
export * from "./form-builder.vue?vue&type=script&lang=ts&"
import style0 from "./form-builder.vue?vue&type=style&index=0&id=00c29dd5&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports